<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="请输入可获奖会员名" v-model="username" class="input-with-select">
          </el-input>
        </div>  
        <div style='display:inline-block;'>
          <el-input placeholder="请输入可获奖的城市" v-model="city" class="input-with-select">
                    <el-button slot="append" icon="el-icon-plus" @click='addFhUser'>添加用户</el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="添加时间">
      <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        prop="username"
        label="会员名">
      </el-table-column>
      <el-table-column
        prop="city"
        label="地区">
      </el-table-column>
      <el-table-column
        prop="ruletip"
        label="规则">
      </el-table-column>
      <el-table-column
        label="操作">
         <template slot-scope="scope"> 
          <el-button type="danger" @click="delFhUser(scope.row.userid)">删除</el-button>
         </template> 
      </el-table-column>
    </el-table>
     
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        username:'',
        city:'',
        processing:false
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/prize/getFhpointsSet",{}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      delFhUser(userid){
        this.$post("/prize/delFhUser",{userid:userid}).then((data)=>{
             if(data.result.success){
                this.$message.success(data.result.info)
                this.getList()
             }else{
                this.$message.error(data.result.info)
             }
        })
      },
      addFhUser(){
         if(this.processing){
             this.$message("请等待操作完成");return false;
         }
         if(this.username==''){
             this.$message("请先输入会员名");return false;
         }
         if(this.city==''){
             this.$message("请先输入城市");return false;
         }
         this.processing=true
         this.$post("/prize/addFhUser",{username:this.username,city:this.city}).then((data)=>{
             this.processing=false
             if(data.result.success){
                this.$message.success(data.result.info)
                this.getList()
             }else{
                this.$message.error(data.result.info)
             }
        })
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
.checkimg{display: block;width: 100%;}
</style>
